// Sign Up routes
export const APPLY = "/apply";
export const AGREEMENT = "/apply/agreement";
export const CHECK_YOUR_EMAIL = "/apply/check-your-email";
export const CHOOSECONNECT = "/chooseConnect";
